import React from "react";
import Resources from "../../../types/Resources";
import {
    CodeStatus,
    getHighestPermitCategory,
    MaritimeEventType,
    PermitCategory,
    PermitType
} from "../../../common/enums";
import { getPermitIcon } from "../../../icons";
import RenewalInfo from "./RenewalInfo";
import FormElement from "../../../types/forms/FormElement";
import { PermitDocument, PermitFormState } from "../../../types/permits";

type PermitHeaderProps = {
    resources: Resources;
    permitDocument: PermitDocument | undefined;
    formState: PermitFormState;
    permitType: PermitType;
    permitNameResource: string | undefined;
};

function hasPermitCategory(formState: any): formState is { permitCategory: FormElement<PermitCategory> } {
    return !!formState.permitCategory;
}

function hasPermitCategories(formState: any): formState is { permitCategories: FormElement<PermitCategory[]> } {
    return (
        !!formState.permitCategories &&
        Array.isArray(formState.permitCategories.value) &&
        formState.permitCategories.value.length > 0
    );
}

function hasMaritimeEventType(formState: any): formState is { maritimeEventType: FormElement<MaritimeEventType> } {
    return !!formState.maritimeEventType;
}

function PermitHeader(props: PermitHeaderProps) {
    const permitCategory = hasPermitCategories(props.formState)
        ? getHighestPermitCategory(props.formState.permitCategories.value)
        : hasPermitCategory(props.formState)
          ? props.formState.permitCategory.value
          : PermitCategory.Other;

    const maritimeEventType = hasMaritimeEventType(props.formState)
        ? props.formState.maritimeEventType.value
        : undefined;

    const isActive = props.formState.positions.some((p) => p.isActive);

    const permitIcon = getPermitIcon(
        props.permitType,
        permitCategory,
        props.permitDocument?.status ?? CodeStatus.New,
        isActive,
        maritimeEventType
    );

    return (
        <>
            <div className="mb-4 mt-4 d-flex align-items-center justify-content-center position-relative">
                <div className="w-100 position-absolute">
                    {props.permitDocument ? (
                        <RenewalInfo permitDocument={props.permitDocument} resources={props.resources} />
                    ) : null}
                </div>
                <div className="d-flex justify-content-center align-items-center me-3 position-relative">
                    <img src={permitIcon.markerSrc} alt={props.permitNameResource} style={{ width: "64px" }} />
                </div>
                <div className="d-flex flex-column fw-bold">
                    <div className="mt-2">{props.permitNameResource}</div>
                    {props.permitDocument ? (
                        <>
                            {(props.permitDocument as any).isAnonymousPermit ? null : (
                                <div>
                                    {props.resources.get("CreatedBy")}: {props.permitDocument.createdByUserName}
                                </div>
                            )}

                            <div>
                                {props.resources.get("Status")}: {props.resources.get(props.permitDocument.status)}
                            </div>
                            <div>
                                {props.resources.get("SequenceIdentifier")}: {props.permitDocument.sequenceIdentifier}-
                                {props.permitDocument.version}
                            </div>
                            {(props.permitDocument as any).isFinished ? (
                                <div>{props.resources.get("IsFinished")}</div>
                            ) : null}
                        </>
                    ) : null}
                </div>
            </div>
        </>
    );
}

export default PermitHeader;
